const Info = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            width="16"
            height="16"
            {...props}
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M7.833 14.3a6.3 6.3 0 100-12.6 6.3 6.3 0 000 12.6zm0 1.2a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm1.5-7.8v4.8h-3V7.7h3zm-1.5-1.2a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export default Info
